// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/avantages/avantages.scss
 ** module id = 87
 ** module chunks = 0 1
 **/